// extracted by mini-css-extract-plugin
export default {"notification":"styles_notification__XzjNd","fontSize":"styles_fontSize__5Ip3V"};